import {createSlice} from "@reduxjs/toolkit";

const initialContestListState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  exportData: [],
  contestData: [],
  contestUsers: [],
  retentionreportlist: [],
  upload: {},
  imageField: undefined,
  screenShots: [],
  totalJoinedPlayers: 0,
  rulesDetails: null,
  timeDetails: null,
  contestShortInfo: null,
  contestExtraInfo: null,
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const ContestListSlice = createSlice({
  
  name: "contestList",
  initialState: initialContestListState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    clearfetchStaffUsers: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.entities = [];
      state.totalCount = 0;
    },
    itemUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = [];
    },
    emptyList: (state, action) => {
      state.error = null;
      state.entities = [];
      // state.totalCount = 0;
      state.exportData = [];
    },
    
    contestListList: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    contestDetails: (state, action) => {
      const { contestData } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.contestData = contestData;
    },
    contestUsersList: (state, action) => {
      const { contestUsers } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.contestUsers = contestUsers;
    },
    imageUploaded: (state, action) => {
      const { entities, imageField} = action.payload;
      // console.log('in e',entities)
      // console.log('in f',imageField)

      state.error = null;
      state.upload = entities;
      state.imageField = imageField;
    },
    saveScreenShot: (state, action) => {
      const { screenShots } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.screenShots = screenShots;
    },
    saveIsHackingProof: (state, action) => {
      const { isHackingProofImages } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.isHackingProofImages = isHackingProofImages;
    },
    saveTotalJoinedPlayers: (state, action) => {
      const { totalJoinedPlayers } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.totalJoinedPlayers = totalJoinedPlayers;
    },
    contestRulesLoading: (state, action) => {
      state.rulesLoading = true;
    },
    contestRules: (state, action) => {
      const { contestData } = action.payload;
      state.rulesLoading = false;
      state.error = null;
      state.rulesDetails = contestData;
    },
    contestTimesLoading: (state, action) => {
      state.timesLoading = true;
    },
    contestTimes: (state, action) => {
      const { contestData } = action.payload;
      state.timesLoading = false;
      state.error = null;
      state.timeDetails = contestData;
    },
    contestShortInfoLoading: (state, action) => {
      state.shortInfoLoading = true;
    },
    contestShortInfo: (state, action) => {
      const { contestData } = action.payload;
      state.shortInfoLoading = false;
      state.error = null;
      state.contestShortInfo = contestData;
    },
    contestExtraInfoLoading: (state, action) => {
      state.extraInforLoading = true;
    },
    contestExtraInfo: (state, action) => {
      state.extraInforLoading = false;
      const { contestData } = action.payload;
      state.error = null;
      state.contestExtraInfo = contestData;
    },
  }
});
